import React, { useEffect, useState } from "react";
import {
  AdditionalInfoSection,
  EmergencyContactsSection,
  HomeCategorySection,
  HomeProfileSection,
} from "../../components";
import "./style.css";
import { IoSearch } from "react-icons/io5";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { constants, CATEGORIES_TYPES } from "../../common";
import { images } from "../../common/images";
import {
  getDashboardDocumentStats,
  getDashboardStats,
  getUserDetails,
} from "../../services/firebaseServices";
const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent,
  );
};

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

const Dashboard = () => {
  const { colors } = constants;
  const navigate = useNavigate();
  const [isSearch, setIsSearch] = useState(false);
  const [uid, setUid] = useState("");
  const [allergiesStats, setAllergiesState] = useState([]);
  const [medicineStats, setMedicineState] = useState([]);
  const [diagnosesStats, setDiagnosisState] = useState([]);
  const [vaccinesStats, setVaccinesState] = useState([]);
  const [docStats, setDocState] = useState([]);
  const [isEmpty, setIsEmpty] = useState(true);
  const [isShow, setIsShow] = useState(true);
  const [userContent, setUserContent] = useState([]);
  const deepLinkURLAndriod =
    "intent://emergencypage#Intent;scheme=intent;package=no.wmc;end";
  const deepLinkURLIOS = "com.wmc-card.app1://emergency";

  const DataListing = [
    {
      mainTitle: `Allergies`,
      type: CATEGORIES_TYPES.allergies,
      dataListing: allergiesStats,
      background: colors.allergiesColor,
      icon: images.allergyIcon,
    },
    {
      mainTitle: `Medicines`,
      type: CATEGORIES_TYPES.medicines,
      dataListing: medicineStats,
      background: colors.medicineColor,
      icon: images.medicineIcon,
    },
    {
      mainTitle: `Diagnoses`,
      type: CATEGORIES_TYPES.diagnoses,
      dataListing: diagnosesStats,
      background: colors.diagnoseColor,
      icon: images.diagnoseIcon,
    },
    {
      mainTitle: `Vaccines`,
      type: CATEGORIES_TYPES.vaccines,
      dataListing: vaccinesStats,
      background: colors.vaccineColor,
      icon: images.vaccineIcon,
    },
    {
      mainTitle: `Documents`,
      type: CATEGORIES_TYPES.documents,
      dataListing: docStats,
      background: colors.documentColor,
      icon: images.documentIcon,
    },
  ];

  const getProfileStats = async (uid) => {
    try {
      let response = await getUserDetails(uid);
      if (response?.email) {
        getDocumentStat("documents", response?.email);
      }
      setUserContent(response || []);
    } catch (error) {}
  };

  const getDocumentStat = async (type, email) => {
    let response = await getDashboardDocumentStats(type, email);
    setDocState(response);
  };
  const getDataFromFirebase = async (uid) => {
    try {
      setIsSearch(true);
      let allergiesResponse = await getDashboardStats("allergies", uid);
      let medicinesResponse = await getDashboardStats("medicine", uid);
      let vaccinesResponse = await getDashboardStats("vaccines", uid);
      let diagnosesResponse = await getDashboardStats("diagnoses", uid);
      setAllergiesState(allergiesResponse);
      setMedicineState(medicinesResponse);
      setVaccinesState(vaccinesResponse);
      setDiagnosisState(diagnosesResponse);
      setIsSearch(false);
      setIsEmpty(false);
    } catch (error) {
      alert(error.message);
    }
  };
  const containerStyle = {
    padding: "5px",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "10px",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "18px",
    marginTop: "0",
    marginBottom: "10px",
  };

  const paragraphStyle = {
    marginTop: "0",
    marginBottom: "10px",
  };

  const platform = isMobile() ? "Mobile" : "Desktop";

  return (
    <div
      style={{
        paddingTop: 60,
        paddingBottom: 80,
        maxWidth: 1440,
        margin: "auto",
        paddingLeft: 20,
        paddingRight: 20,
      }}
    >
      {platform === "Mobile" && isShow && (
        <div className="app-open">
          <div className="app-head"> See WMC in...</div>
          <div className="app-open-in">
            <div className="browser">
              <img src="/wmc-logo.png" width={50} />
              WMC APP
            </div>
            {isIOS() ? (
              <a id="link" href={deepLinkURLIOS}>
                Open App
              </a>
            ) : (
              <a id="link" href={deepLinkURLAndriod}>
                Open App
              </a>
            )}
          </div>
          <div className="app-open-in">
            {isIOS() ? (
              <div className="browser">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height={30}
                  aria-label="Safari"
                  role="img"
                  viewBox="0 0 512 512"
                >
                  <rect width="512" height="512" rx="15%" fill="#ffffff" />
                  <radialGradient id="a">
                    <stop stopColor="#0bd" offset="0" />
                    <stop offset="1" stopColor="#17d" />
                  </radialGradient>
                  <g transform="matrix(4 0 0 4 256 256)">
                    <g stroke="#eee" fill="none">
                      <circle r="52.5" fill="url(#a)" strokeWidth="5" />
                      <circle
                        r="45"
                        strokeDasharray="1.25 8.175"
                        strokeDashoffset=".5"
                        strokeWidth="5.5"
                      />
                      <circle
                        r="42.5"
                        strokeDasharray="1.25 7.65"
                        strokeDashoffset="5"
                        strokeWidth="10"
                      />
                    </g>
                    <path d="M6 6l-12-12l-29 39" fill="#eee" />
                    <path d="M6 6l-12-12l41-28" fill="#f55" />
                    <path
                      opacity=".3"
                      d="M-35 33l7-5-3 5 37-27 28-35-4 2 4-6"
                    />
                  </g>
                </svg>
                Safari{" "}
              </div>
            ) : (
              <div className="browser">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30px"
                  height="30px"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M16.0005 2.00394C16.0005 2.00394 24.2527 1.63495 28.6278 9.90002H15.2983C15.2983 9.90002 12.7828 9.81923 10.634 12.8601C10.0167 14.1364 9.3532 15.4511 10.0978 18.0422C9.02517 16.2315 4.40332 8.21246 4.40332 8.21246C4.40332 8.21246 7.66332 2.33069 16.0004 2.00394H16.0005Z"
                    fill="#EF3F36"
                  />
                  <path
                    d="M28.1994 22.986C28.1994 22.986 24.3915 30.2938 15.0244 29.9325C16.1818 27.9373 21.691 18.4305 21.691 18.4305C21.691 18.4305 23.022 16.3008 21.4518 12.9256C20.6531 11.7531 19.8391 10.5268 17.2157 9.87324C19.3261 9.85413 28.6045 9.87324 28.6045 9.87324C28.6045 9.87324 32.0805 15.6281 28.1994 22.986Z"
                    fill="#FCD900"
                  />
                  <path
                    d="M3.85931 23.0433C3.85931 23.0433 -0.588992 16.1044 4.41095 8.20068C5.56452 10.1959 11.0737 19.7027 11.0737 19.7027C11.0737 19.7027 12.262 21.917 15.9772 22.2475C17.3932 22.1437 18.8669 22.0553 20.7497 20.1217C19.7117 21.9516 15.0551 29.9476 15.0551 29.9476C15.0551 29.9476 8.31134 30.0706 3.8592 23.0433H3.85931Z"
                    fill="#61BC5B"
                  />
                  <path
                    d="M15.0205 30.0013L16.8955 22.2053C16.8955 22.2053 18.9557 22.0437 20.6842 20.1562C19.6115 22.0362 15.0205 30.0013 15.0205 30.0013Z"
                    fill="#5AB055"
                  />
                  <path
                    d="M9.71973 16.089C9.71973 12.6523 12.5168 9.86523 15.9658 9.86523C19.4148 9.86523 22.2119 12.6523 22.2119 16.089C22.2119 19.5257 19.4148 22.3127 15.9658 22.3127C12.5168 22.3089 9.71973 19.5257 9.71973 16.089Z"
                    fill="white"
                  />
                  <path
                    d="M10.7656 16.0892C10.7656 13.2292 13.0921 10.9072 15.9663 10.9072C18.8366 10.9072 21.1669 13.2254 21.1669 16.0892C21.1669 18.9494 18.8406 21.2714 15.9663 21.2714C13.0959 21.2714 10.7656 18.9494 10.7656 16.0892Z"
                    fill="url(#paint0_linear_87_7098)"
                  />
                  <path
                    d="M28.6007 9.87673L20.8808 12.1333C20.8808 12.1333 19.7157 10.4302 17.2119 9.87673C19.384 9.86515 28.6007 9.87673 28.6007 9.87673Z"
                    fill="#EACA05"
                  />
                  <path
                    d="M9.94735 17.7577C8.86313 15.8855 4.40332 8.2124 4.40332 8.2124L10.1209 13.8481C10.1209 13.8481 9.53441 15.0514 9.75441 16.7735L9.94724 17.7577H9.94735Z"
                    fill="#DF3A32"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_87_7098"
                      x1="15.9661"
                      y1="10.9804"
                      x2="15.9661"
                      y2="20.9594"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#86BBE5" />
                      <stop offset="1" stop-color="#1072BA" />
                    </linearGradient>
                  </defs>
                </svg>
                Chrome{" "}
              </div>
            )}
            <a id="link" className="continue" onClick={() => setIsShow(false)}>
              Continue
            </a>
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img
          src="images/WMC_logo_slogan_black.png"
          alt="WMC Logo"
          height={60}
          style={{ marginBottom: 20, marginTop: 20, cursor: "pointer" }}
        />
        <h1 style={{ color: "black", textAlign: "center" }}>
          Emergency loginn
        </h1>
      </div>
      <div>
        <div className="instruction" style={containerStyle}>
          <h2 style={titleStyle}>Locate the code:</h2>
          <p style={paragraphStyle}>
            1. Obtain the person's physical WMC card.
          </p>
          <p style={paragraphStyle}>
            2. Tear open the card and identify the QR code.
          </p>
          <p style={paragraphStyle}>
            3. Scan the QR code to gain access to the medical data.
          </p>
        </div>
        <div className="instruction" style={containerStyle}>
          <h2 style={titleStyle}>If you don’t have a QR reader:</h2>
          <p style={paragraphStyle}>
            Identify the password on the top right corner of the card.
          </p>
        </div>
      </div>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%", maxWidth: "864px" }}>
          <div className="plan-labels">{"Pleaser enter password below."}</div>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <div className="input-field-container full-width-input-generic">
              <input
                className="input-field-generic"
                autoComplete="off"
                type="text"
                onChange={(e) => {
                  setUid(e.target.value);
                }}
                placeholder="Enter User Id"
                value={uid}
              />
              <button
                style={{
                  marginRight: 25,
                  border: "none",
                  backgroundColor: "#fafafa",
                  cursor: "pointer",
                }}
                disabled={uid?.length == 0}
                onClick={() => {
                  // setDocState([]);
                  // getDataFromFirebase(uid);
                  // getProfileStats(uid);
                  navigate(`/${uid}`);
                }}
              >
                <IoSearch size={20} />
              </button>
            </div>
            {uid?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginLeft: 10,
                }}
              >
                <button
                  onClick={() => {
                    setAllergiesState([]);
                    setMedicineState([]);
                    setVaccinesState([]);
                    setDiagnosisState([]);
                    setDocState([]);
                    setUid("");
                    setIsEmpty(true);
                  }}
                  style={{
                    padding: "20px",
                    borderRadius: 20,
                    backgroundColor: colors.primary,
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ color: "white" }}>Clear</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 20,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress size={30} color="info" />
          <div style={{ marginTop: 5 }}>
            <span>Please wait while data is fetching..</span>
          </div>
        </div>
      ) : (
        !isEmpty && (
          <div style={{ width: "100%", maxWidth: 600, margin: "0 auto" }}>
            <HomeProfileSection item={userContent} />
            <AdditionalInfoSection notes={userContent?.medicalNotes} />
            <EmergencyContactsSection contacts={userContent?.emergencyContact} />
            {DataListing.map(
              ({ mainTitle, type, background, icon, dataListing }) => {
                return (
                  <HomeCategorySection
                    mainTitle={mainTitle}
                    type={type}
                    icon={icon}
                    background={background}
                    dataListing={dataListing}
                  />
                );
              },
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Dashboard;
